import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import KeyDecisionContentEvent from "../../key-decisions/event/KeyDecisionContentEvent";
import AppHierarchicalDialogPlayer from "../framework/player/AppHierarchicalDialogPlayer";

export default class AppNGTDialogPlayer extends NGTDialogPlayer {
    constructor(variableManager, playSessionModel, languagePack, config, dispatcher, dialogFactory) {
        super(variableManager, playSessionModel, languagePack, config, dispatcher, dialogFactory);
        this._dialogPlayer = new AppHierarchicalDialogPlayer(dialogFactory, 100);
    }

    addEventListeners() {
        super.addEventListeners();
        this._dialogPlayer.addEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, this._handleKeyDecisionContentIgnored, this);
    }

    removeEventListeners() {
        super.removeEventListeners();
        this._dialogPlayer.removeEventListener(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, this._handleKeyDecisionContentIgnored, this);
    }

    _handleKeyDecisionContentIgnored(event) {
        this.eventDispatcher.dispatch(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, event.data);
    }
}